<div *ngIf="invite">
  <app-learner-portal-registration-form
    [registerError]="registerError"
    [invite]="invite"
    (submitted)="onSubmit($event)"
  ></app-learner-portal-registration-form>
</div>
